import Form from 'mobx-react-form';
import { muiFormBindings } from 'forms/utils/muiFormBindings';
import { plugins } from 'forms/utils/formPlugins';
import { FieldsDefinitions } from 'mobx-react-form/lib/models/FormInterface';
import { createUser } from 'utils/labels';
import { formOptions } from 'forms/utils/formOptions';
import { isEmail, isPasswordValid, isRequired } from 'forms/utils/validators';

const fields: FieldsDefinitions = [
  {
    name: 'username',
    label: createUser.username,
    bindings: 'TextField',
    value: '',
    validators: [isRequired],
  },
  {
    name: 'password',
    label: createUser.password,
    bindings: 'TextField',
    type: 'password',
    value: '',
    validators: [isRequired, isPasswordValid],
  },
  {
    name: 'email',
    label: createUser.email,
    bindings: 'TextField',
    value: '',
    validators: [isRequired, isEmail],
  },
  {
    name: 'enabled',
    label: createUser.enabled,
    bindings: 'Checkbox',
    value: true,
  },
  {
    name: 'internal',
    label: createUser.internal,
    bindings: 'Checkbox',
    value: true,
  },
  {
    name: 'admin',
    label: createUser.admin,
    bindings: 'Checkbox',
    value: false,
  },
];

export function createForm() {
  return new Form({ fields }, { plugins, bindings: muiFormBindings, options: formOptions });
}
